// Fix wishlist header link navigation
document.addEventListener('DOMContentLoaded', function() {
  // Ensure wishlist links work properly
  var wishlistLinks = document.querySelectorAll('a[href="/pages/wishlist"]');
  
  wishlistLinks.forEach(function(link) {
    // Remove any event listeners that might be preventing default
    var newLink = link.cloneNode(true);
    link.parentNode.replaceChild(newLink, link);
    
    // Add explicit click handler
    newLink.addEventListener('click', function(e) {
      // Don't prevent default - let the link work normally
      // Just ensure we're navigating
      window.location.href = '/pages/wishlist';
    });
    
    // Ensure link is styled correctly
    newLink.style.cursor = 'pointer';
    newLink.style.textDecoration = 'none';
  });
  
  // Also ensure mini-cart links don't interfere
  var miniCartLinks = document.querySelectorAll('.mini-cart-icon');
  miniCartLinks.forEach(function(link) {
    if (link.getAttribute('href') === '#') {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
      });
    }
  });
});
